function loginPageHandler(product, event, data) {

    const { userId = "", name: userName = "", email: userEmail = "", mobile: userContact = "", balance: walletBalance = "", role = "" } = data
    let finalData = {}
    switch (event) {
        case 'login': finalData = { userId, userName, userEmail, userContact, walletBalance, role }
            break;

    }
    return finalData;
}

module.exports = { loginPageHandler }